export default {"src":"/_next/static/media/ccl.8d11a845.svg","height":130,"width":334,"blurWidth":0,"blurHeight":0};